import Image from "../../Home/components/Image";
import { SpeakCta, ASSESSMENT_URL } from "../../Home/components/SpeakCta";

/* Hero for the TNT Group ("Turo Host Tips & Tricks") partner landing page. Left column carries the
   partner-specific title, subcopy and CTA; the right column features the partner's hero artwork
   with the "Rentid Preferred Partner 2026" badge in a glass frame over its top-left corner.
   Images are the v0 originals converted to WebP (public/img/tnt-group). */
export function TntHero() {
  return (
    <section className="relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 md:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Copy */}
          <div className="order-1 flex flex-col">
            <h1 className="font-heading text-[32px] sm:text-5xl md:text-[56px] font-bold tracking-tighter leading-[1.05] text-foreground text-balance">
              Your Fleet. Your Brand. Let’s grow Your Business.
            </h1>

            <p className="mt-4 sm:mt-5 text-sm sm:text-base font-medium text-foreground text-pretty max-w-md">
              Exclusive benefits for Turo Host Tips &amp; Tricks members.
            </p>

            <p className="text-lg sm:text-lg text-muted-foreground leading-relaxed text-pretty max-w-md mt-3 sm:mt-4">
              Take the next step in your rental journey with the tools to launch and manage direct rentals. From bookings and
              insurance to driver verification, payments, telematics, and automation, Rentid brings everything together.
            </p>

            <div className="mt-6 sm:mt-8 flex flex-col sm:flex-row gap-3">
              <SpeakCta href={ASSESSMENT_URL} label="Start for Free" />
            </div>
          </div>

          {/* Image */}
          <div className="order-2 relative w-full">
            <div className="pointer-events-none absolute -left-4 top-0 z-20 -translate-y-1/2 select-none rounded-2xl border border-white/30 bg-white/20 p-1 shadow-lg backdrop-blur-md sm:-left-6 sm:p-1.5">
              <Image
                src="/img/tnt-group/rentid-preferred-partner-2026.webp"
                alt="Rentid Preferred Partner 2026"
                width={900}
                height={239}
                className="h-auto w-40 rounded-[10px] sm:w-56"
              />
            </div>
            <div className="relative z-10 overflow-hidden rounded-3xl border border-border shadow-2xl">
              <Image
                src="/img/tnt-group/turo-hosts-hero.webp"
                alt="Turo Hosts Tips & Tricks — a black sports car with glowing headlights in front of red-lit smoke"
                width={1640}
                height={924}
                className="h-auto w-full"
                priority
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
